import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=76c50b20&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"
import style0 from "./Message.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports